import { SavedSearchSubscribeldTop } from '@components/SavedSearchSubscribeldTop';
import { GetTelegramClickButton, useIsAutoSearch } from '@containers/SearchSubscribeTelegramContainer';

type SearchSubscribeTelegramTopContainerProps = {
  filter?: string;
  productId?: string | null;
  className?: string
};

export const SearchSubscribeTelegramTopContainer:
React.FC<SearchSubscribeTelegramTopContainerProps> = ({
  filter,
  productId,
  className,
}) => {
  const click = GetTelegramClickButton();
  const isAutoSearch = useIsAutoSearch();

  if (isAutoSearch) {
    return null;
  }

  return (
    <SavedSearchSubscribeldTop
      className={className}
      filter={filter}
      onTelegramClick={click}
      productId={productId}
    />
  );
};

export default SearchSubscribeTelegramTopContainer;
